import {EinheiteneingabeService} from "./services/einheiteneingabe.service";

export const einheiteneingabeProviders = [
  EinheiteneingabeService
];
